import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, finalize, from, catchError, throwError, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/authentication/auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AjaxInterceptorService } from './AjaxInterceptorService';
import { CacheService } from '../services/cashe-service';
import { CurrentUserService } from '../services/current-user.service';
import { APP_ROUTER } from '../models/app.route';


@Injectable()
export class JWTInterceptor implements HttpInterceptor {
  public ApiRequestCount: number = 0;

  constructor(
    private router: Router,
    private authService: AuthService,
    private jwtHelper: JwtHelperService,
    private ajaxInterceptorSvc: AjaxInterceptorService,
    private userService:CurrentUserService,
    private CurrentUserService:CurrentUserService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return from(this.interceptRequest(request, next));
  }

  private async interceptRequest(request: HttpRequest<any>, next: HttpHandler) {
    let apiUrl = environment.apiUrl;
    if (request.url.toLocaleLowerCase().includes('api/')) {
      this.ajaxInterceptorSvc.setProgressSMasktatus(true);
      this.ApiRequestCount++;
      request = request.clone({
        url: `${apiUrl}${request.url}`,
        withCredentials: true
      });
    }

    return next
      .handle(this.addAuthenticationToken(request))
      .pipe(
        finalize(() => {
          if (
            request.url.toLowerCase().includes('api/')
          ) {
            this.ApiRequestCount--;
            if (this.ApiRequestCount == 0) {
              this.ajaxInterceptorSvc.setProgressSMasktatus(false);
            }
          }
        }),
        catchError((error) => {
          console.error('catchError', error);
          return throwError(error).pipe(
            tap(null, (error) => {
              if (error.status == '500')
              this.router.navigateByUrl('/500');

              else if (error.status == '401'){
                this.CurrentUserService.logout();
                                // this.router.navigateByUrl('/401');

              }
            })
          );
        })
      )
      .toPromise();
  }

  

  addAuthenticationToken(request) {
    // Get access token from Local Storage
    var accessToken=CacheService.getToken();
    // if (!accessToken &&(request.url.includes("Auth/GetIAMUrl") || request.url.includes("Auth/GetToken"))) {
    //   return request;
    // }
    // // If access token is null this means that user is not logged in
    // // And we return the original request
    // if (!accessToken && !environment.skipCallingIAM) {
    //   this.triggerSSOIfNoToken(request);
    //   return request;
    // }

    // We clone the request, because the original request is immutable
    return request.clone({
      setHeaders: {
        'Authorization': `Bearer ${accessToken}`
      }
    });

  }
  triggerSSOIfNoToken(request: HttpRequest<any>) {
    if (!CacheService.getToken() && this.ApiRequestCount==0) {
      this.authService.initiateSSO();
    }
  }
}

